/**
 * Satellite / NDVI analysis is OFF unless a real imagery provider is wired in.
 * The current service produces deterministic simulated numbers, so it must not
 * be shown to users. Set VITE_ENABLE_SATELLITE_ANALYSIS=true only when
 * satelliteAnalysisService returns live data.
 */
export const SATELLITE_ANALYSIS_ENABLED = import.meta.env['VITE_ENABLE_SATELLITE_ANALYSIS'] === 'true';

/**
 * The new landlord home (next actions, headline numbers, ageing, leases ending, land).
 * VITE_ENABLE_DASHBOARD_HOME=true forces it on, =false forces it off. When unset it follows the demo build
 * (VITE_DEMO_LOGIN_ENABLED=true), so the demo shows it and production keeps the existing Overview until the
 * owner decides to flip it.
 */
const dashboardFlag = import.meta.env['VITE_ENABLE_DASHBOARD_HOME'];
export const DASHBOARD_HOME_ENABLED =
  dashboardFlag === 'true' || (dashboardFlag !== 'false' && import.meta.env['VITE_DEMO_LOGIN_ENABLED'] === 'true');
